import React from 'react';
import { FaInbox, FaSearch, FaShoppingBag, FaHeart } from 'react-icons/fa';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
  variant?: 'default' | 'search' | 'orders' | 'favorites' | 'products';
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actionText,
  onAction,
  variant = 'default',
  className = '',
}) => {
  const getVariantConfig = () => {
    switch (variant) {
      case 'search':
        return {
          icon: FaSearch,
          title: 'Sonuç Bulunamadı',
          description: 'Arama kriterlerinize uygun sonuç bulunamadı.',
          iconColor: 'text-blue-400',
        };
      case 'orders':
        return {
          icon: FaShoppingBag,
          title: 'Henüz Sipariş Yok',
          description: 'Henüz hiç sipariş vermemişsiniz.',
          iconColor: 'text-green-400',
        };
      case 'favorites':
        return {
          icon: FaHeart,
          title: 'Favori Sipariş Yok',
          description: 'Henüz favori sipariş eklenmemiş.',
          iconColor: 'text-pink-400',
        };
      case 'products':
        return {
          icon: FaInbox,
          title: 'Ürün Bulunamadı',
          description: 'Bu kategoride henüz ürün bulunmuyor.',
          iconColor: 'text-purple-400',
        };
      default:
        return {
          icon: FaInbox,
          title: 'İçerik Bulunamadı',
          description: 'Görüntülenecek içerik bulunamadı.',
          iconColor: 'text-gray-400',
        };
    }
  };

  const config = getVariantConfig();
  const FinalIcon = Icon || config.icon;
  const finalTitle = title || config.title;
  const finalDescription = description || config.description;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`text-center py-12 ${className}`}
    >
      <FinalIcon className={`mx-auto text-5xl ${config.iconColor} mb-4`} />
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{finalTitle}</h3>
      <p className="text-gray-600 mb-6 max-w-md mx-auto">{finalDescription}</p>
      {actionText && onAction && (
        <button
          onClick={onAction}
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          {actionText}
        </button>
      )}
    </motion.div>
  );
};
